import React,{useState,useEffect} from 'react';
import './portfolio.css';
import Isotope from 'isotope-layout';
import portfolios from './portfolioList';
import SinglePortfolio from './SinglePortfolio';
import {Link} from 'react-router-dom';


function Portfolio() {

    const [isotope, setIsotope] = useState(null);
    const [filterKey, setfilterKey] = useState('All');
    const BUTTONS = [ "All" , "Static", "React", "Typescript"];
    
    useEffect(() => {
        setIsotope(
            new Isotope('.filter-container', {
                itemSelector: '.filter-item',
                layoutMode: 'fitRows',
            })
            );
        }, []);
        
    useEffect(() => {
        if (isotope) {
            // sanity check
            filterKey === 'All'
            ? isotope.arrange({ filter: "*" })
            : isotope.arrange({ filter: `.${filterKey.toLowerCase()}` });

        }
    }, [isotope, filterKey]);
        
    return (
        <div className="portfolio" id="portfolio">
            <div className="container">

                <div className="portfolio-header-container">
                    <div className="about-header-container">
                            <h4>My Creative Work</h4>
                            <h3>My Latest Work</h3>
                    </div>

                    <ul>
                        {BUTTONS.map((button) =>(
                           <li className={`button ${filterKey === button ? "active" : ''}`} onClick={() => setfilterKey(button)}>{button}</li>
                        ))}
                    </ul>

                </div>{/* portfolio header end */}
                

                <div className="filter-container">

                    {portfolios.slice(0,9).map(portfolio =>{
                        return <SinglePortfolio key={portfolio.url} content={portfolio} />
                    })}

                </div> {/* filter end */}
 
                <div className="button-container">
                    <Link to="portfolio" className="button link-button"> View All Projects</Link>
                </div>
            </div>   

             <img src={process.env.PUBLIC_URL + '/image/icons/dot.png'} className="dot" alt="Ashish Gupta"/>   
     </div>   
    )
}

export default Portfolio
